import React, { useRef, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import moment from 'moment/moment'

import { database } from '@smartcoop/database'
import { productService } from '@smartcoop/database/services/productService'
import { shoppingOrganizationService } from '@smartcoop/database/services/shoppingOrganizationService'
import { selectCurrentOrganization } from '@smartcoop/stores/organization/selectorOrganization'
import { SyncActions } from '@smartcoop/stores/sync'
import { selectProductsLoading, selectProductsUpdatedAt, selectShoppingOrganizationsLoading, selectShoppingOrganizationsUpdatedAt } from '@smartcoop/stores/sync/selectorSync'
import { momentBackDateTimeFormat } from '@smartcoop/utils/dates'
import RegisterOrderForm from '@smartcoop/web-containers/forms/shoppingPlatform/order/RegisterOrderForm'
import { useRoutes } from '@smartcoop/web-containers/routes/authenticated'

const RegisterOrderScreen = () => {
  const registerOrderRef = useRef(null)

  const dispatch = useDispatch()

  const history = useHistory()

  const { routes } = useRoutes()

  const onSuccess = useCallback(() => history.push(routes.orderList.path), [history, routes.orderList.path])
  const onCancel = useCallback(() => history.goBack(), [history])

  const defaultValues = history?.location?.state?.defaultValues

  const currentOrganization = useSelector(selectCurrentOrganization)
  const productsLoading = useSelector(selectProductsLoading)
  const productsUpdatedAt = useSelector(selectProductsUpdatedAt)
  const shoppingOrganizationsUpdatedAt = useSelector(selectShoppingOrganizationsUpdatedAt)
  const shoppingOrganizationsLoading = useSelector(selectShoppingOrganizationsLoading)

  const loadProducts = useCallback(
    () => {
      if(!productsLoading && currentOrganization?.id) {
        dispatch(SyncActions.setProductsLoading(true))
        productService(database).syncProducts({ purchasing: true,  updatedAt: productsUpdatedAt }, () => {
          dispatch(SyncActions.setProductsLoading(false))
        })
        const newDate = moment().subtract(4, 'minutes').format(momentBackDateTimeFormat)
        dispatch(SyncActions.setProductsUpdatedAt(newDate))
      }
    },
    [currentOrganization, dispatch, productsLoading, productsUpdatedAt]
  )

  const loadShoppingOrganizations = useCallback(
    () => {
      if(!shoppingOrganizationsLoading && currentOrganization?.id) {
        dispatch(SyncActions.setShoppingOrganizationsLoading(true))
        shoppingOrganizationService(database).syncShoppingOrganizations({ updatedAt: shoppingOrganizationsUpdatedAt }, currentOrganization?.id, () => {
          dispatch(SyncActions.setShoppingOrganizationsLoading(false))
        })
        const newDate = moment().subtract(4, 'minutes').format(momentBackDateTimeFormat)
        dispatch(SyncActions.setShoppingOrganizationsUpdatedAt(newDate))
      }
    },
    [currentOrganization, dispatch, shoppingOrganizationsLoading, shoppingOrganizationsUpdatedAt]
  )

  useEffect(() => {
    loadProducts()
    loadShoppingOrganizations()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <RegisterOrderForm
      formRef={ registerOrderRef }
      onSuccess={ onSuccess }
      onCancel={ onCancel }
      defaultValues={ defaultValues }
      shoppingOrganizationsLoading={ shoppingOrganizationsLoading }
      organizationId={ currentOrganization?.id }
    />
  )
}

export default RegisterOrderScreen
